import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

interface BasicButtonProps {
    disabled?: boolean;
    onClick?: () => void;
    label?: string;
}

const BasicButton = (props: BasicButtonProps) => (
    <Button
        disabled={props.disabled}
        sx={{
            backgroundColor: props.disabled ? "#adadad" : "#C00000",
            height: { sm: 40, md: 45 },
            width: "150px",
            pl: 4,
            pr: 4,
            borderRadius: "30px",
            transition: "all 0.2s ease-in-out",
            "&: hover": {
                backgroundColor: "#C00000",
                opacity: 0.7,
            },
        }}
        onClick={props.onClick}
    >
        <Typography
            sx={{
                color: props.disabled ? "#898989" : "#fefefe",
                fontWeight: "bold",
            }}
        >
            {props.label}
        </Typography>
    </Button>
);

export default BasicButton;
